import { PickersDayProps, PickersDay } from "@mui/x-date-pickers/PickersDay";

import { useWeekValue } from "./WeekContext";
import WeekDay from "./WeekDay";
import { useWeekHover } from "./WeekHoverContext";

function WeekDayComponent(props: PickersDayProps) {
  const externalValue = useWeekValue();
  const { hover, setHover } = useWeekHover();
  const { day, ...other } = props;

  if (!externalValue) return <PickersDay {...props} />;

  const start = externalValue.startOf("week");
  const end = externalValue.endOf("week");

  const isSelected = day.isSame(start, "day") || day.isSame(end, "day") || (day.isAfter(start) && day.isBefore(end));

  const hoverStart = hover?.startOf("week");
  const hoverEnd = hover?.endOf("week");

  const isHoveredWeek =
    hover && (day.isSame(hoverStart, "day") || day.isSame(hoverEnd, "day") || (day.isAfter(hoverStart) && day.isBefore(hoverEnd)));

  return (
    <WeekDay
      {...other}
      day={day}
      selected={isSelected}
      isFirst={day.isSame(start, "day")}
      isLast={day.isSame(end, "day")}
      isHoveredWeek={isHoveredWeek as boolean}
      onMouseEnter={() => setHover(day)}
      onMouseLeave={() => setHover(null)}
    />
  );
}

export default WeekDayComponent;
